import styled from "styled-components";

import DEFAULT from "../../../assets/images/empty-image.svg";
import CRYPTO from "../../../assets/images/services/crypto.svg";
import ADVC from "../../../assets/images/services/advcash.svg";
import UAPAY from "../../../assets/images/services/uapay.svg";
import HUOBI from "../../../assets/images/services/huobi.svg";
import DECTA from "../../../assets/images/services/decta.svg";
import ADG from "../../../assets/images/services/adgroup.svg";
import KUNA from "../../../assets/images/services/kuna.svg";
import WHITEBITE from "../../../assets/images/services/whitebit.svg";
import SPOYNT from "../../../assets/images/services/spoynt.svg";
import CURRENCYLAYER from "../../../assets/images/services/currencylayer.svg"

const icon = {
  tag: String
};

const changeImg = (icon) => {
  switch (icon) {
    case "UaPay" :
      return `
        background-image: url(${UAPAY});
      `;
    case "AdvCash" :
      return `
        background-image: url(${ADVC});
      `;
    case "Huobi" :
      return `
        background-image: url(${HUOBI});
      `;
    case "Decta" :
      return `
        background-image: url(${DECTA});
      `;
    case "AdGroup" :
      return `
        background-image: url(${ADG});
      `;
    case "Kuna" :
      return `
        background-image: url(${KUNA});
      `;
    case "WhiteBit" :
      return `
        background-image: url(${WHITEBITE});
      `;
    case "Spoynt" :
      return `
        background-image: url(${SPOYNT});
      `;
    case "CurrencyLayer" :
      return `
        background-image: url(${CURRENCYLAYER});
      `;
    case "Crypto1" :
    case "Crypto3" :
      return `
        background-image: url(${CRYPTO});
      `;
    default :
      return `
        background-image: url(${DEFAULT});
      `;
  }
};

export const StyledConnectionWrapper = styled.div`
  width: 100%;
  height: 255px;
  padding: 20px;
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-areas: 'status'
                       'serviceIcon'
                       'name';
  align-items: center;
  border: 1px solid ${({theme}) => theme.surface.border};
  border-radius: 5px;
  .connection__active {
    display: inline-grid;
    justify-content: end;
  }
  cursor: pointer;
`;

export const StyledConnectionLogo = styled("div", icon)`
  width: 155px;
  height: 115px;
  margin: 0 auto;
  ${({ icon }) => changeImg(icon)};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  grid-area: serviceIcon;
`;

export const StyledConnectionStatusWrapper = styled.div`
  padding-bottom: 15px;
  border-bottom: 1px solid ${({theme}) => theme.surface.borderSoft};
  display: grid;
  grid-area: status;
  .connection__status-item {
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;

export const StyledConnectionStatus = styled.div`
  width: 50px;
  height: 20px;
  color: ${({theme}) => theme.text.inverse};
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ enable, theme }) => enable === true ? theme.button.success : theme.button.danger};
  border-radius: 30px;
`;

export const StyledConnectionName = styled.h4`
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  grid-area: name;
`;